import type { IReportCardInfo } from '@/types';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

export const ReportApiService = Symbol('ReportApiService');

interface GetReportParams {
    projectId: string;
    taskGroupKey: string;
    isRetry?: boolean;
}

export interface ReportApiService {
    getReportCardData(params: GetReportParams): Promise<IReportCardInfo>;
}

@injectable()
export class ReportApiServiceImpl extends PsHttpService implements ReportApiService {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getReportCardData(params: GetReportParams) {
        const url = `/project/${params.projectId}/${params.taskGroupKey}?retry=${!!params.isRetry}`;
        return this.get<PatSnapCommonResponseData<IReportCardInfo>>({
            url,
        }).then((res) => {
            return res.data as IReportCardInfo;
        });
    }
}
